module.exports = __webpack_public_path__ + "static/media/logo.543ad38e.svg";